var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-croppie',{ref:"croppieRef",attrs:{"enableOrientation":true,"enableResize":false,"viewport":{ width: 300, height: 400, type: 'circle' },"boundary":{ width: 600, height: 600 },"maxZoom":4}})}
var staticRenderFns = []

export { render, staticRenderFns }